
namespace TabAurous.Inventory {
    import fld = RepairItemsBOMRow.Fields;

    @Serenity.Decorators.registerClass()
    export class RepairItemsBOMEditor extends _Ext.BOMGridEditor<RepairItemsBOMRow> { 
        protected getDialogType() { return RepairItemsBOMDialog; }
        protected getLocalTextPrefix() { return RepairItemsBOMRow.localTextPrefix; } 

        constructor(container: JQuery) {
            super(container);

            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.slickGrid.setOptions({ rowHeight: 30 });

            this.view.onDataChanged.subscribe(() => {
                if (this.view.getItems().length > 0) {
                    (this.parentDialog as RepairItemsDialog).CalculateTotals();
                }
            });
        } 
        // #region Column Add -Remove
        protected getColumns() {

            var columns = super.getColumns();
            var amt = ctx => ColumnFormatter.AmountFormatter(ctx, this);
            Q.first(columns, x => x.field === fld.BomRate).format = amt;
            return columns;
        }
        public inputsChange(e: JQueryEventObject,) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row) as any;
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');
            var id = this.id(item);
            var pending = this.pendingChanges[id];

            // *** Format Number ***
            var effective = this.getEffectiveValue(item, field);
            var oldText: string = input.hasClass('numeric')
                ? Q.formatNumber(effective, '0.00')
                : effective as string;

            var value;
            var iscustomeritem = item.IsCustomerItem;
            if (iscustomeritem) {
                q.alert('', 'Cannot change rate of Customer Item', false, 2999);
                input.val(oldText);
                input.focus();
                return;
            }

            // *** Validate Decimal & Integer***
            if (field === fld.BomRate) {
                value = Q.parseDecimal(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Decimal'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            }

            else if (input.hasClass('numeric')) {
                var i = Q.parseInteger(text);
                if (isNaN(i) || i > 32767 || i < 0) {
                    Q.notifyError(Q.text('Validation.Integer'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
                value = i;
            }
            else {
                value = text;
            }

            // *** Update Weight, Amount etc on Pieces Change***
            if (field === fld.BomRate && value > 0) {
                if (item.CalcOnId == 3) {
                    item.BomAmount = value * item.Pieces;
                } else if (item.CalcOnId == 4 || item.CalcOnId == 5) {
                    item.ItemTypeId == 104 ? item.BomAmount = value * item.Weight * item.Purity : item.BomAmount = value * item.Weight;
                }
                item[field] = value;
            }



            this.view.updateItem(id, item);
            (this.parentDialog as any).CalculateTotals();
            this.view.refresh();

            if (input.hasClass('numeric'))
                value = Q.formatNumber(value, '0.00');

            if (input.hasClass('integer'))
                value = Q.formatNumber(value, '0');

            input.val(value).addClass('dirty');
        }


    }
}